<div class="boxFilter__divider" *ngIf="showDivider">
  <app-ds-divider></app-ds-divider>
</div>
<div class="boxFilter__cont">
  <ng-container *ngIf="showAccordion">
    <app-ds-accordion
      [text]="label"
      [size]="accordionSize"
      [initState]="show"
      (clickEvent)="toggle($event)">
    </app-ds-accordion>
  </ng-container>
  <div class="boxFilter__body" [class.active]="show">
    <div class="boxFilter__body-content">
      <ng-content></ng-content>
    </div>
  </div>
</div>